export const enumFrequency = (frequency: string): string => {
  switch (frequency) {
    case 'monthly': return 'Mensal'
    case 'yearly': return 'Anual'
    default: return frequency
  }
}
